export enum EJournalItemType {
  Message = 'message',
  Warning = 'warning',
  Success = 'success',
  Error = 'error'
}
